import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class DomainsService {
	private hasDefinedDomainObj = new BehaviorSubject<boolean>(false);
	hasDefinedDomainObservable = this.hasDefinedDomainObj.asObservable();

	projectId: number;

	productionDomain = 'www.smarttelemetrics.com';
	stagingDomain = 'staging.smarttelemetrics.com';
	developmentDomain = 'telemetrics.iotah-view.org';

	iotahProductionDomain = 'devices.iotah-view.com';
	iotahStagingDomain = 'staging.iotah-view.com';
	iotahDevelopmentDomain = 'iotah-view.org';

	charglinkProductionDomain = 'devices.charglink.com';
	charglinkStagingDomain = 'staging.charglink.com';
	charglinkDevelopmentDomain = 'charglink.iotah-view.org';

	fredProductionDomain = 'fred.smarttelemetrics.com';
	fredStagingDomain = 'staging.fred.com';
	fredDevelopmentDomain = 'fred.iotah-view.org';

	battlinkProductionDomain = 'devices.batt-link.com';
	battlinkStagingDomain = 'staging.batt-link.com';
	battlinkDevelopmentDomain = 'battlink.iotah-view.org';

	brmProductionDomain = 'devices.smartbrm.com';

	imProductionDomain = 'www.iotemeter.com';
	imStagingDomain = 'iotemeter.com';
	imDevelopmentDomain = 'iotemeter.org';

	imProdDomainUrl = 'https://www.iotemeter.com';
	imStagDomainUrl = 'https://staging.iotemeter.com';
	imDevDomainUrl = 'https://iotemeter.org';

	mobileAppLinks = {
		google_play: {
			iotah: 'https://play.google.com/store/apps/details?id=com.smartchargetech.iotah&pcampaignid=web_share&pli=1',
			chargLink: 'https://play.google.com/store/apps/details?id=com.smartchargetech.charglink&pcampaignid=web_share',
			battlink: 'https://play.google.com/store/apps/details?id=com.smartchargetech.telemetrics',
			smart_telemetric: 'https://play.google.com/store/apps/details?id=com.smartchargetech.telemetrics',
			fred: 'https://play.google.com/store/apps/details?id=com.batterywatering.fred'
		},
		app_store: {
			iotah: 'https://apps.apple.com/us/app/iotah/id1534874730',
			chargLink: 'https://apps.apple.com/us/app/charglink/id6448758620',
			battlink: 'https://apps.apple.com/us/app/id6741804567',
			smart_telemetric: 'https://apps.apple.com/us/app/id6741804567',
			fred: 'https://apps.apple.com/jo/app/fred-by-bwt/id1219048316'
		}
	};


	get isProductionDomain() {
		return [this.productionDomain, this.iotahProductionDomain, this.charglinkProductionDomain, this.battlinkProductionDomain, this.fredProductionDomain].includes(window.location.hostname);
	}

	get isStagingDomain() {
		return [this.stagingDomain, this.iotahStagingDomain, this.charglinkStagingDomain, this.battlinkStagingDomain, this.fredStagingDomain].includes(window.location.hostname);
	}

	get isDevelopmentDomain() {
		return [this.developmentDomain, this.iotahDevelopmentDomain, this.charglinkDevelopmentDomain, this.battlinkDevelopmentDomain, this.fredDevelopmentDomain].includes(window.location.hostname);
	}

	get isIotah() {
		return this.projectId == 0;
	}

	get isChargLink() {
		return this.projectId == 1;
	}

	get isBattlink() {
		return this.projectId == 2;
	}

	get isSmartTelemetrics() {
		return this.projectId == 3;
	}

	get isFred() {
		return this.projectId == 4;
	}

	get baseTitleKey() {
		return this.isFred ? 'g.fred' : 'g.smart_telemetrics';
	}

	hasDefinedDomain() {
		return this.projectId != undefined;
	}

	setProjectId(projectId: number): void {
		this.projectId = projectId;
		this.updateHasDefinedDomain();
	}

	private updateHasDefinedDomain(): void {
		this.hasDefinedDomainObj.next(this.hasDefinedDomain());
	}

	//! to do - use the config on the common file
	getAppLinks() {
		let app_store = this.mobileAppLinks.app_store.smart_telemetric;
		let google_play = this.mobileAppLinks.google_play.smart_telemetric;

		if (this.isIotah) {
			app_store = this.mobileAppLinks.app_store.iotah;
			google_play = this.mobileAppLinks.google_play.iotah;
		} else if (this.isChargLink) {
			app_store = this.mobileAppLinks.app_store.chargLink;
			google_play = this.mobileAppLinks.google_play.chargLink;
		} else if (this.isFred) {
			app_store = this.mobileAppLinks.app_store.fred;
			google_play = this.mobileAppLinks.google_play.fred;
		}

		return { app_store, google_play };
	}
}
